import { Fancybox } from '@fancyapps/ui';

export default {
    init() {
        this.initCloseTarget();
        this.initOpenTarget();
        this.initToggleTarget();
        this.initHoverAndPointerDetection();
        this.initFancybox();
    },

    initCloseTarget() {
        const closeTargetButtons = document.querySelectorAll('[data-close-target]');

        if (!closeTargetButtons.length) return;

        closeTargetButtons.forEach((closeTargetButton) => {
            closeTargetButton.addEventListener('click', () => {
                const selector = closeTargetButton.dataset.closeTarget;
                const target = document.querySelector(selector);

                if (!target) return;

                target.style.display = 'none';
                target.dispatchEvent(new Event('selfClosed'));
            });
        });
    },

    initOpenTarget(display) {
        const openTargetButtons = document.querySelectorAll('[data-open-target]');

        if (!openTargetButtons.length) return;

        openTargetButtons.forEach((openTargetButton) => {
            openTargetButton.addEventListener('click', () => {
                const selector = openTargetButton.dataset.openTarget;
                const target = document.querySelector(selector);

                if (!target) return;

                target.style.display = display ?? 'block';
                target.dispatchEvent(new Event('selfOpened'));
            });
        });
    },

    initToggleTarget(display) {
        const toggleTargetButtons = document.querySelectorAll('[data-toggle-target]');
        if (!toggleTargetButtons.length) return;

        toggleTargetButtons.forEach((toggleButton) => {
            toggleButton.addEventListener('click', (e) => {
                e.preventDefault();

                const selector = toggleButton.dataset.toggleTarget;
                const target = document.querySelector(selector);
                if (!target) return;

                const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
                const newExpanded = !isExpanded;

                // ARIA
                toggleButton.setAttribute('aria-expanded', String(newExpanded));

                // Affichage + accessibilité
                if (newExpanded) {
                    target.hidden = false;
                    target.style.display = display ?? 'block';
                    target.dispatchEvent(new Event('selfOpened'));
                } else {
                    target.hidden = true;
                    target.style.display = 'none';
                    target.dispatchEvent(new Event('selfClosed'));
                }

                // Libellé accessible
                const { toggleLabelCollapsed, toggleLabelExpanded } = toggleButton.dataset;
                if (toggleLabelCollapsed || toggleLabelExpanded) {
                    const sr = toggleButton.querySelector('.sr-only');
                    const nextText = newExpanded ? toggleLabelExpanded : toggleLabelCollapsed;
                    if (sr && nextText) {
                        sr.textContent = nextText;
                    } else if (nextText) {
                        toggleButton.setAttribute('aria-label', nextText);
                    }
                }
            });
        });
    },

    initFancybox() {
        Fancybox.bind('[data-fancybox]');
    },

    // Méthode pour détecter le hover et le pointeur fin
    initHoverAndPointerDetection() {
        const mediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
        document.documentElement.dataset.hoverSupported = mediaQuery.matches;

        if (mediaQuery.matches) {
            console.log("L'appareil supporte le hover et a un pointeur fin.");
        } else {
            console.log("L'appareil ne supporte pas le hover ou n'a pas un pointeur fin.");
        }
    },
};
